export const HOME = '/';
export const CATEGORIES_NAME = '/categories/:categoryName';
export const SHOPPING_BASKET = '/your-shopping-basket';
export const FAVOURITES = '/favourites';